import React, { useMemo, useRef, useState, useCallback } from 'react'
import t from '~t'
import { useDispatch, useSelector } from 'react-redux'
import { makeSort, makeSorts } from '~data/selectors/bookmarks'
import { changeSort } from '~data/actions/bookmarks'

import { Popover, Layout, Radio, Label, Icon, Button } from '~ui'

export default function BookmarksHeaderSort({ spaceId = 0 }) {
    const dispatch = useDispatch()
    const getSort = useMemo(() => makeSort(), [])
    const getSorts = useMemo(() => makeSorts(), [])

    const sort = useSelector(state => getSort(state, spaceId))
    const sorts = useSelector(state => getSorts(state, spaceId))

    const pin = useRef(null)
    const [menu, setMenu] = useState(false)

    const options = useMemo(
        () => ({
            'sort':     t.s('manual'),
            'created':  t.s('byDate') + ' ↑',
            '-created': t.s('byDate') + ' ↓',
            'title':    t.s('byName') + ' (A-Z)',
            '-title':   t.s('byName') + ' (Z-A)',
            'domain':   t.s('sites') + ' (A-Z)',
            '-domain':  t.s('sites') + ' (Z-A)',
            'score':    t.s('byRelevance')
        }),
        []
    )

    const onContextMenuClick = useCallback(e => {
        e.preventDefault()
        setMenu(prev => !prev)
    }, [])

    const onContextMenuClose = useCallback(() => setMenu(false), [])

    const onSortClick = useCallback(
        e => {
            dispatch(changeSort(spaceId, e.currentTarget.getAttribute('data-sort')))
        },
        [dispatch, spaceId]
    )

    return (
        <>
            <Button
                ref={pin}
                title={t.s('sortBy')}
                variant={sort != 'sort' ? 'accent' : 'ghost'}
                onMouseDown={onContextMenuClick}>
                <Icon name={'sort_' + sort} />

                <span className='hide-on-small-body'>
                    {options[sort] || ''}
                </span>
            </Button>

            {menu ? (
                <Popover pin={pin} onClose={onContextMenuClose}>
                    <Layout>
                        <Label>{t.s('sortBy')}</Label>
                        <div>
                            {Object.keys(options).map(
                                item =>
                                    sorts[item] &&
                                    sorts[item].enabled && (
                                        <Radio
                                            key={item}
                                            autoFocus={item == sort}
                                            data-sort={item}
                                            checked={item == sort}
                                            readOnly
                                            onClick={onSortClick}>
                                            <Icon name={'sort_' + item} />
                                            {options[item]}{item == 'sort' ? ' (Drag\'n\'drop)' : ''}
                                        </Radio>
                                    )
                            )}
                        </div>
                    </Layout>
                </Popover>
            ) : null}
        </>
    )
}
